import { romeApi, utils } from "framework";

const state = {
    brokerId: null,
    userId: null,
    taxId: null,
    isActive: null,
    salesforceId: null,
    phone: null,
    fax: null,
    phoneExtension: null,
    useAgencyOptions: null,
    rsm: null,
    cam: null,
    flexAe: null,
    cobraAe: null,
    firstName: null,
    lastName: null,
    email: null,
    username: null,
    agencyId: null,
    title: null,
    options: [],
    employers: [],
    agencies: [],
    cams: [],
    flexCrm: null,
    ready: false,
};

const getters = {};

const actions = {
  async load(context, data) {
      let id = data.agencyId;
      if (!id || context.state.agencyId == id) return;
      var broker = await romeApi.get(`/broker/${id}`);
      context.commit('setBroker', broker);
      context.state.ready = true;
  },
  async update(context, data) {
      let id = context.state.brokerId;
      if (!id) return;
      let postData = _.omit(context.state, "ready");
      _.assign(postData, data);
      await romeApi.post(`/broker/${id}`, postData);
      context.commit("setBroker", data);
  },
};

const mutations = {
  setBroker(state, data) {
      utils.copyCommonProperties(data, state);
  },
  clearBroker(state) {
      utils.resetStoreStateProperties(state);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/broker/x-broker.js